import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    main: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    },
    icon: {
      fontSize: '14px',
    },
    circle: {
      width: '24px',
      height: '24px',
      color: 'white',
      backgroundColor: '#5081FF',
      borderRadius: '50%',
      marginRight: '15px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '166%',
    },
    disabledCircle: {
      width: '24px',
      height: '24px',
      color: 'white',
      backgroundColor: 'rgba(0, 0, 0, 0.38);',
      borderRadius: '50%',
      marginRight: '15px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '166%',
    },
    activeText: {
      fontWeight: 500,
      fontsize: '14px',
      lineHeight: '157%',
      letterspacing: '0.1px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    disabledText: {
      fontWeight: 400,
      fontsize: '14px',
      lineHeight: '157%',
      letterspacing: '0.1px',
      color: 'rgba(0, 0, 0, 0.54);es',
    },
    flex: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '23%',
    },
    hr: {
      alignSelf: 'center',
      background: 'black',
      width: '100%',
      height: '1px',
    },
    horizontalLine: {
      width: '50%',
    },
    title: {
      fontSize: 25,
      color: 'black',
      display: 'block',
      margin: '0 auto 10px',
      '@media (max-width: 768px)': {
        fontSize: 22,
      },
      '@media (max-width: 480px)': {
        fontSize: 20,
      },
    },
    alertContainer: {
      display: 'flex',
      padding: '8px',
      minHeight: 'calc(100vh - 106px)',
      justifyContent: 'center',
    },
    alertboxes: {
      width: '500px',
      margin: '40px',
      display: 'flex',
      flexDirection: 'column',
      //  flex-direction:"column"
    },
    alertmessage: {
      display: 'flex',
      borderRadius: '4px',
      margin: '0 auto',
      width: '500px',
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)),#007dff',
    },
    alertbox: {
      display: 'flex',
      padding: '8px 18px',
    },
    alertIcon: {
      marginRight: '10px',
      color: '#007dff',
    },
    alertTitle: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600,
      color: '#621b16',
    },
    paper: {
      // marginTop: '80px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: 40,
      marginBottom: '18px',
      boxShadow: 'none',
      width: '100%',
      maxWidth: '500px',
      '@media (min-height: 768px)': {
        marginTop: 'calc(50vh - 350px)',
      },
      '@media (max-width: 960px)': {
        padding: 30,
        marginTop: '60px',
        maxWidth: '450px',
      },
      '@media (max-width: 768px)': {
        padding: 24,
        marginTop: '40px',
        maxWidth: '400px',
        margin: '40px auto 0',
      },
      '@media (max-width: 600px)': {
        padding: 20,
        marginTop: '30px',
        maxWidth: '350px',
        margin: '30px 16px 0',
      },
      '@media (max-width: 480px)': {
        padding: 16,
        marginTop: '20px',
        maxWidth: '100%',
        margin: '20px 12px 0',
      },
    },
    paperHelp: {
      marginTop: '80px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: 20,
      boxShadow: 'none',
      '@media (min-height: 768px)': {
        marginTop: 'calc(50vh - 350px)',
      },
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    formControl: {
      marginTop: '22px',
      width: '100%',
      '@media (max-width: 480px)': {
        marginTop: '16px',
      },
    },
    widthFull: {
      width: '100%',
      marginTop: '10px',
    },
    marginTop: {
      marginTop: '15px',
    },
    link: {
      marginTop: '10px',
      marginRight: theme.spacing(1),
      width: '100%',
      display: 'block',
      alignItems: 'flex-end',
      color: '#737373',
    },
    button: {
      width: '100%',
      boxShadow: 'none',
      textTransform: 'none',
      lineHeight: '36px',
      padding: `8px 22px`,
      fontSize: '14px',
      '@media (max-width: 768px)': {
        padding: '10px 20px',
        fontSize: '13px',
      },
      '@media (max-width: 480px)': {
        padding: '12px 16px',
        fontSize: '12px',
      },
    },
    container: {
      minHeight: 'calc(100vh - 106px)',
      backgroundPosition: 'bottom, left top',
      backgroundRepeat: 'repeat-x, repeat',
      backgroundSize: 'contain, cover',
      padding: '0 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // marginBottom:'80px',
      '@media (max-width: 960px)': {
        padding: '0 12px',
        minHeight: 'calc(100vh - 90px)',
        // marginBottom:'70px',
      },
      '@media (max-width: 768px)': {
        padding: '0 8px',
        minHeight: 'calc(100vh - 80px)',
        marginBottom: '60px',
      },
      '@media (max-width: 480px)': {
        padding: '0 4px',
        minHeight: 'calc(100vh - 60px)',
        // marginBottom:'50px',
      },
    },

    //    container: {
    //   display: 'flex',
    //   justifyContent: 'center',
    //   padding: theme.spacing(1),
    //   backgroundPosition: 'bottom, left top',
    //   backgroundRepeat: 'repeat-x, repeat',
    //   backgroundSize: 'contain, cover',
    //   minHeight: 'calc(100vh - 106px)',
    // },
    containers: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(1),
      backgroundPosition: 'bottom, left top',
      backgroundRepeat: 'repeat-x, repeat',
      backgroundSize: 'contain, cover',
    },
    formContainer: {
      margin: theme.spacing(5),
      display: 'flex',
      flexDirection: 'column',
      width: '500px',
      '@media (max-width: 768px)': {
        width: '80%',
      },
    },
    topBars: {
      display: 'flex',
      width: '30%',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      margin: '40px 0',
    },
    topBar: {
      display: 'flex',
      alignItems: 'center',
      height: '106px',
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #E0E0E0',
      padding: '0 40px',
      '@media (max-width: 960px)': {
        height: '90px',
        padding: '0 24px',
        '& svg': {
          width: '130px !important',
          height: '48px !important',
          marginLeft: '0 !important',
        },
      },
      '@media (max-width: 768px)': {
        height: '80px',
        padding: '0 16px',
        '& svg': {
          width: '120px !important',
          height: '44px !important',
          marginLeft: '0 !important',
        },
      },
      '@media (max-width: 480px)': {
        height: '60px',
        padding: '0 12px',
        '& svg': {
          width: '100px !important',
          height: '36px !important',
          marginLeft: '0 !important',
        },
      },
    },
    error: {
      color: 'red',
      fontsize: 10,
    },
    footer: {
      position: 'absolute',
      bottom: '32px',
      right: '50%',
      transform: 'translate(50%,-50%)',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '26px',
      textAlign: 'center',
      color: 'rgba(0, 0, 0, 0.54)',
      '@media (max-height: 768px)': {
        position: 'relative',
        bottom: 0,
        right: 0,
        transform: 'none',
        margin: '15px 0',
      },
    },
    divider: {
      margin: `${theme.spacing(1.5)}px -${theme.spacing(2.5)}px ${theme.spacing(2.5)}px`,
    },
    forgotPassword: {
      fontWeight: 500,
      fontSize: '15px',
      lineHeight: '26px',
      letterSpacing: '0.46px',
      textTransform: 'uppercase',
      color: 'rgba(0, 0, 0, 0.54)',
      '@media (max-width: 768px)': {
        fontSize: '13px',
        lineHeight: '22px',
      },
      '@media (max-width: 480px)': {
        fontSize: '12px',
        lineHeight: '20px',
      },
    },
    row: {
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginBottom: theme.spacing(2),
      flexBasis: '100%',
      flexWrap: 'wrap',
    },
    titles: {
      fontSize: 20,
      textAlign: 'center',
      width: '290px',
      color: 'black',
      display: 'block',
      margin: '10px auto',
    },
    loginWithGoogleBtn: {
      transition: 'background-color 0.3s, box-shadow 0.3s',
      textTransform: 'uppercase',
      width: '100%',
      textAlign: 'center',
      padding: '12px 16px 12px 42px',
      border: 'none',
      borderRadius: '3px',
      boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25)',
      color: '#757575',
      fontSize: '14px',
      fontWeight: 500,
      backgroundImage:
        'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMiAxMyAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=)',
      backgroundColor: 'white',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '60px center',
      '&:hover': {
        boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25)',
      },
      '&:active': {
        backgroundColor: '#eeeeee',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 0 3px #c8dafc',
      },
      '&:disabled': {
        filter: 'grayscale(100%)',
        backgroundColor: '#ebebeb',
        boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25)',
        cursor: 'not-allowed',
      },
      '@media (max-width: 768px)': {
        padding: '12px 16px',
        backgroundPosition: '13px 14px',
        textAlign: 'center',
      },
    },
    input: {
      minWidth: 250,
      flexGrow: 1,
      fontSize: 16,
      color: 'rgb(0 0 0 / 87%)',
      '& .MuiInputBase-input.Mui-disabled': {
        color: 'rgb(0 0 0 / 87%)',
      },
    },
  }),
  {
    index: 1,
  }
);
